// Copyright 2018 The Chromium Authors. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
import '../shell/shell.js';
import '../../panels/timeline/timeline-meta.js';
import * as Main from '../main/main.js';

new Main.MainImpl.MainImpl();
